var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLoginIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    style: {
      fillOpacity: 0
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M452.75,237.05a9.89,9.89,0,0,0-9.92-9.92H244.05l48.07-48.06a9.89,9.89,0,0,0,0-14l-15.87-15.87a9.9,9.9,0,0,0-14,0l-66.47,66.47L185.08,226.3l-.06.06a.23.23,0,0,0-.07.07L174,237.34s-5.09,5-5.09,10.93,5.15,11,5.15,11l11,11,77.13,77.13a9.89,9.89,0,0,0,14,0l15.87-15.87a9.87,9.87,0,0,0,0-14L244,269.41H442.83a9.89,9.89,0,0,0,9.92-9.92Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256.09,440.25a32.91,32.91,0,0,0,33-33V398H106.38a16.86,16.86,0,0,1-16.87-16.91V118.89A16.86,16.86,0,0,1,106.38,102H289.06V92.7a32.9,32.9,0,0,0-33-33H80.22a32.93,32.93,0,0,0-33,33V407.24a32.94,32.94,0,0,0,33,33Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLoginIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/login_icon.ed10e26b.svg";
export { ForwardRef as ReactComponent };